<div id="modal_payment" class="modal fade"  data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="modal-title" translate>Payment</h5>
      </div>

      <form #form="ngForm" novalidate>
        <div class="modal-body">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <input class="form-control" [ngClass]="{'error':!nameOnCard.valid && nameOnCard.touched}" type="text" name="nameOnCard" [placeholder]="translate.instant('Name On Card')" [(ngModel)]="thePayment.nameOnCard" #nameOnCard="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
              </div>

              <div class="form-group">
                <input class="form-control" [ngClass]="{'error':!cardNo.valid && cardNo.touched && !isCardNoValid}" type="text" name="cardNo" [placeholder]="translate.instant('Card No')" [(ngModel)]="thePayment.cardNo" (keyup)="checkCardNo(cardNo.value, cardNo.valid)" #cardNo="ngModel" required minlength="13" maxlength="16" pattern="^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})|((?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}))$">
              </div>

              <div class="row">
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="form-group">
                        <input class="form-control" [ngClass]="{'error':(!mm.valid && mm.touched) || (yy.valid && mm.touched && !isMMYYValid)}" type="text" name="mm" placeholder="mm" [(ngModel)]="thePayment.mm" #mm="ngModel" (keyup)="checkMMYY(mm.value, mm.valid, yy.value, yy.valid)" required minlength="2" maxlength="2"  pattern="^((0[1-9])|(1[0-2]))$"> <!-- month as 0-12 -->
                      </div>
                    </div>

                    <div class="col-sm-5">
                      <div class="form-group">
                        <input class="form-control" [ngClass]="{'error':(!yy.valid && yy.touched) || (mm.valid && yy.touched && !isMMYYValid)}" type="text" name="yy" placeholder="yy" [(ngModel)]="thePayment.yy" #yy="ngModel" (keyup)="checkMMYY(mm.value, mm.valid, yy.value, yy.valid)" required minlength="2" maxlength="2"  pattern="^([2-4][0-9])$"> <!-- year as 17-27 -->
                      </div>
                    </div>

                    <div class="col-sm-2"> </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!cvc.valid && cvc.touched}" type="text" name="cvc" placeholder="cvc" [(ngModel)]="thePayment.cvc" #cvc="ngModel" required minlength="3" maxlength="4" pattern="[0-9]+">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <img src="../../../assets/images/iyzico.png" alt="İyzico" class="contain"/>
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <img src="../../../assets/images/pci.png" alt="PCI" class="contain"/>
                  </div>
                </div>
              </div>

              <div class="row" class="col-sm-11 center-block">
                <div class="input-group">
                  <input type="text" class="form-control" [ngClass]="{'error':!discountCoupon.valid && discountCoupon.touched}" name="discountCoupon" [placeholder]="translate.instant('Discount Coupon')" [(ngModel)]="thePayment.discountCoupon" #discountCoupon="ngModel" min="1" pattern="^([0-9a-zA-ZçÇöÖşŞıİğĞüÜ]*)$">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-outline-secondary" [disabled]="!discountCoupon.valid || thePayment.discountCoupon.length==0" (click)="checkCoupon(discountCoupon.value, discountCoupon.valid)" translate>Apply</button>
                  </span>
                </div>
              </div>

            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <div class="btn-group">
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Company'}" (click)="paymentGroup='Company'" translate>Company</button>
                  <button type="button" class="btn btn-default" [ngClass]="{'active': paymentGroup=='Individual'}" (click)="paymentGroup='Individual'" translate>Invidual</button>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Company'">
                <div class="form-group">
                  <input  class="form-control" [ngClass]="{'error': !title.valid && title.touched }" type="text" name="title" [placeholder]="translate.instant('Title')" [(ngModel)]="thePayment.company.title" #title="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+)$">
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error': !name.valid && name.touched}" type="text" name="name" [placeholder]="translate.instant('Name')" [(ngModel)]="thePayment.individual.name" #name="ngModel" required pattern="^(?:(?:^| )[a-zA-ZsçÇöÖşŞıİğĞüÜ ,.'-]+ *){2,}$">
                </div>
              </div>

              <div class="row">
                <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!taxOffice.valid && taxOffice.touched}" type="text" name="taxOffice" [placeholder]="translate.instant('Tax Office')" [(ngModel)]="thePayment.company.taxOffice" #taxOffice="ngModel" required pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>

                <div *ngIf="paymentGroup=='Company'" class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!taxNo.valid && taxNo.touched}" type="text" name="taxNo" [placeholder]="translate.instant('Tax No')" [(ngModel)]="thePayment.company.taxNo" #taxNo="ngModel" required minlength="10" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>

              <div *ngIf="paymentGroup=='Individual'">
                <div class="form-group">
                  <input class="form-control" [ngClass]="{'error':!citizenId.valid && citizenId.touched}" type="text" id="citizenId" name="citizenId" [placeholder]="translate.instant('Citizen ID')" [(ngModel)]="thePayment.individual.citizenId" #citizenId="ngModel" required minlength="11" maxlength="11" pattern="[0-9]+">
                </div>
              </div>

              <div class="form-group">
                <textarea class="form-control" [ngClass]="{'error':!address.valid && address.touched}" name="address" [placeholder]="translate.instant('Address')" [(ngModel)]="thePayment.address" #address="ngModel" rows="3" cols="50" required minlength="5" maxlength="255" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ0-9 '-.,:/]*)$"></textarea>
              </div>

              <div class="form-group">
                <input class="form-control" [ngClass]="{'error':!zipCode.valid && zipCode.touched}" type="text" name="zipCode" [placeholder]="translate.instant('Zip Code')" [(ngModel)]="thePayment.zipCode" #zipCode="ngModel" required minlength="3" maxlength="10" pattern="^(\d{5}([\-]\d{4})?)?([0-9]{3,4})?([0-9]{5}[\-]?[0-9]{3})?([A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9])?([1-9][0-9]{3}\s?[a-zA-Z]{2})?(\d{3}-\d{4})?((L\s*(-|—|–))\s*?[\d]{4})?([0-9]{2}\-[0-9]{3})?(((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3})?(\d{3}\s?\d{2})?([A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})?$">
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!city.valid && city.touched}" type="text" name="city" [placeholder]="translate.instant('City')" [(ngModel)]="thePayment.city" #city="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .]*)$">
                  </div>
                </div>

                <div class="col-sm-6">
                  <div class="form-group">
                    <input class="form-control" [ngClass]="{'error':!province.valid && province.touched}" type="text" name="province" [placeholder]="translate.instant('Province')" [(ngModel)]="thePayment.province" #province="ngModel" required maxlength="50" pattern="^([a-zA-ZsçÇöÖşŞıİğĞüÜ .,]*)$">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="modal-footer text-center">
            <button *ngIf="action=='upgrade'" type="button" class="btn btn-default active btn-size" (click)="upgradeSubscription(form.value)" [disabled]="!form.valid || !isCardNoValid || !isMMYYValid" data-dismiss="modal">{{'PAY' | translate}} {{price || plan?.price}}</button>
            <button *ngIf="action=='update'" type="button" class="btn btn-default active btn-size" (click)="updateSubscription(form.value)" [disabled]="!form.valid || !isCardNoValid || !isMMYYValid" data-dismiss="modal" translate>Update Subscription</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div id="modal_threeds" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content" align="center">
      <div class="modal-header">
        <button class="close" type="button" data-dismiss="modal">×</button>
        <h5 class="modal-title" translate>3D Verification</h5>
      </div>
      <div id="iframecontainer"></div>
    </div>
  </div>
</div>
